class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');

		if (this.input) {
			this.input.form.addEventListener(
				"reset",
				this.onFormReset.bind(this)
			);

			this.input.addEventListener(
				"input",
				debounce((event) => {
					this.onChange(event);
				}, 300).bind(this)
			);
		}
	}

	shouldResetForm() {
		return !document.querySelector(
			'[aria-selected="true"] a'
		);
	}

	onFormReset(event) {
		event.preventDefault();

		if (this.shouldResetForm()) {
			this.input.value = "";
			this.input.focus();
		}
	}
}

customElements.define("search-form", SearchForm);

function escapeShopifySearchValue(value) {
	return value
		.replace(/\\/g, "\\\\")
		.replace(/:/g, "\\:")
		.replace(/\(/g, "\\(")
		.replace(/\)/g, "\\)");
}
  
function buildMainSearchQuery(searchTerm) {
	const terms = searchTerm
		.trim()
		.split(/\s+/)
		.filter(Boolean)
		.map((term) => escapeShopifySearchValue(term));

	if (!terms.length) {
		return "";
	}

	const productTitleQuery = terms
		.map((term) => `title:${term}*`)
		.join(" ");

	const variantTitleQuery = terms
		.map((term) => `variants.title:${term}*`)
		.join(" ");

	return `(${productTitleQuery}) OR (${variantTitleQuery})`;
}
 
function initMainSearchForm() {
	const form = document.querySelector(
		"[data-main-search-form]"
	);

	if (!form) {
		return;
	}

	const input = form.querySelector(
		"[data-main-search-input]"
	);

	if (!input) {
		return;
	}

	form.addEventListener("submit", (event) => {
		const searchTerm = input.value.trim();

		if (!searchTerm) {
			event.preventDefault();
			return;
		}

		if (
			searchTerm.includes("title:") ||
			searchTerm.includes("variants.title:")
		) {
			return;
		}

		event.preventDefault();

		const searchQuery =
			buildMainSearchQuery(searchTerm);

		if (!searchQuery) {
			return;
		}

		sessionStorage.setItem(
			"mainSearchOriginalTerm",
			searchTerm
		);

		const destination = new URL(
			form.action || "/search",
			window.location.origin
		);

		destination.searchParams.set(
			"q",
			searchQuery
		);

		destination.searchParams.set(
			"options[prefix]",
			"none"
		);

		destination.searchParams.set(
			"sort_by",
			"relevance"
		);

		window.location.href =
			destination.pathname +
			destination.search;
	});
}

if (document.readyState === "loading") {
	document.addEventListener(
		"DOMContentLoaded",
		initMainSearchForm
	);
} else {
	initMainSearchForm();
}